// extracted by mini-css-extract-plugin
export default {"not_found__container":"not_found_not_found__container__3cqZ4","not_found__content":"not_found_not_found__content__FaJ+z","not_found__img":"not_found_not_found__img__vcBme"};